import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../appMaterial/app-material.module';
import { TermsComponent } from './terms.component';
import { TermsService } from './terms-service';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
    imports: [AppMaterialModule, CommonModule, FlexLayoutModule],
    exports: [TermsComponent],
    declarations: [TermsComponent],
    providers: [TermsService]
})
export class TermsModule {}
